import store from "@/store";
import request from "@/utils/request";


export async function getCsKjquizList(params) {
    console.log("@@ get list : getCsKjquizList");
    let result = request.get("/api/cs/kjquiz/",{params});
    return result;
}

export async function saveCsKjquiz(params) {
    console.log("@@ post save : saveCsKjquiz");
    let result = request.post(`/api/cs/kjquiz/`,params);
    return result;
}

// 현재 사용중인 카테고리 리스트를 반환한다.
// 카테고리 관리에서 삭제시 확인용으로 사용.
export async function getUsedCategoryList() {
    console.log("@@ post save : getUsedCategoryList");
    let result = request.post(`/api/cs/kjquiz/usedcategory`,{});
    return result;
}
